import { httpGet, httpPost } from "utils/httpRequest"

export const getReportedPosts = async (page = 1, pageSize = 20) => {
  const resp = await httpGet(`admin/community/reported-posts?page=${page}&pageSize=${pageSize}`)
  const raw = resp?.data
  const payload = (raw && raw.data) ? raw.data : raw
  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : []
  return {
    data: rows,
    total: payload?.total ?? 0,
    page: payload?.page ?? page,
    pageSize: payload?.pageSize ?? pageSize,
  }
}

export const ignoreReport = async (reportId) => {
  const resp = await httpPost(`admin/community/reported-posts/${reportId}/ignore`, {})
  return resp.data
}

export const removeReportedPost = async (postId) => {
  const resp = await httpPost(`admin/community/reported-posts/${postId}/remove`, {})
  return resp.data
}

export const banAuthorByPost = async (postId) => {
  const resp = await httpPost(`admin/community/reported-posts/${postId}/ban-author`, {})
  return resp.data
}

export const getReportedComments = async (page = 1, pageSize = 20) => {
  const resp = await httpGet(`admin/community/reported-comments?page=${page}&pageSize=${pageSize}`)
  const raw = resp?.data
  const payload = (raw && raw.data) ? raw.data : raw
  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : []
  return {
    data: rows,
    total: payload?.total ?? 0,
    page: payload?.page ?? page,
    pageSize: payload?.pageSize ?? pageSize,
  }
}

export const ignoreCommentReport = async (reportId) => {
  const resp = await httpPost(`admin/community/reported-comments/${reportId}/ignore`, {})
  return resp.data
}

export const removeReportedComment = async (commentId) => {
  const resp = await httpPost(`admin/community/reported-comments/${commentId}/remove`, {})
  return resp.data
}

export const banAuthorByComment = async (commentId) => {
  const resp = await httpPost(`admin/community/reported-comments/${commentId}/ban-author`, {})
  return resp.data
}


